/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ParqInputs */

const en_us2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health questionnaire (PAR-Q)`)
};

const pt_br2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário de saúde (PAR-Q)`)
};

const es_419_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuestionario de salud (PAR-Q)`)
};

const pt_pt2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionário de saúde (PAR-Q)`)
};

const fr_fr2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionnaire de santé (PAR-Q)`)
};

const de_de2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesundheitsfragebogen (PAR-Q)`)
};

const it_it2_search_field_parq = /** @type {(inputs: Search_Field_ParqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questionario sulla salute (PAR-Q)`)
};

/**
* | output |
* | --- |
* | "Health questionnaire (PAR-Q)" |
*
* @param {Search_Field_ParqInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_parq = /** @type {((inputs?: Search_Field_ParqInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ParqInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_parq(inputs)
	if (locale === "es-419") return es_419_search_field_parq(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_parq(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_parq(inputs)
	if (locale === "de-DE") return de_de2_search_field_parq(inputs)
	if (locale === "it-IT") return it_it2_search_field_parq(inputs)
	return en_us2_search_field_parq(inputs)
});
export { search_field_parq as "search.field_parq" }